import { FC } from 'react';

import { airplaneStates } from '../../store/slices/highflyerAirPlane/types';

import styles from './DarkBg.module.css';

interface DarkBgProps {
  airplaneCurrentState: airplaneStates;
}

const DarkBg: FC<DarkBgProps> = ({ airplaneCurrentState }) => {
  if (airplaneCurrentState != airplaneStates.FLYING) return null;
  return <div className={styles.darkbg}></div>;
};

export default DarkBg;
